import { Controller } from '@hotwired/stimulus';
import { grantGoogleMapsConsent, readGoogleMapsConsent } from '../consent/google_maps_consent.mjs';

export default class extends Controller {
    static targets = [
        'mapBanner',
        'mapView'
    ];

    connect() {
        this.onInitialized = () => this.onConsentInitialized();
        this.onCmpEvent = () => this.onConsentEvent();
        window.addEventListener('UC_UI_INITIALIZED', this.onInitialized);
        window.addEventListener('UC_UI_CMP_EVENT', this.onCmpEvent);
        this.onConsentInitialized();
    }

    disconnect() {
        window.removeEventListener('UC_UI_INITIALIZED', this.onInitialized);
        window.removeEventListener('UC_UI_CMP_EVENT', this.onCmpEvent);
    }

    onConsentInitialized() {
        if (readGoogleMapsConsent()) {
            this.revealMap();
            return;
        }
        if (this.consentRequested) {
            this.loadMap();
        }
    }

    onConsentEvent() {
        this.consentRequested = false;
        if (readGoogleMapsConsent()) {
            this.revealMap();
        }
    }

    async loadMap(event) {
        if (event?.type === 'keydown') {
            event.preventDefault();
        }

        if (this.grantInFlight) {
            return;
        }

        const cmpMissing = typeof UC_UI === 'undefined';
        this.grantInFlight = true;
        try {
            const granted = await grantGoogleMapsConsent();
            if (!granted) {
                this.consentRequested = cmpMissing;
                return;
            }

            this.consentRequested = false;
            this.revealMap();
        } finally {
            this.grantInFlight = false;
        }
    }

    revealMap() {
        const iframe = this.mapViewTarget.querySelector('iframe');
        const bannerHadFocus = this.mapBannerTarget.contains(document.activeElement);
        if (iframe && !iframe.src) {
            iframe.src = iframe.dataset.src;
        }
        this.mapBannerTarget.style.display = 'none';
        this.mapViewTarget.style.display = 'block';
        if (iframe && bannerHadFocus) {
            iframe.focus();
        }
    }
}
